module.exports = __webpack_public_path__ + "media/images/emblems/Moeriken-Wildegg-blason-b29dbee70a3908196138529a660830bf.png";